import React from "react";
import RouteConfig from "./routers/RouteConfig";

const App = () => {
  return (
    <div className="App font-avenir">
      <RouteConfig />
    </div>
  );
};

export default App;
